import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import {environment} from '@/environments/environment';
import { CampaignClient } from '../models/campaign-client.interface';

@Injectable({ providedIn: 'root' })
export class CampaignService {
  private readonly baseUrl = `${environment.apiUrl}/campaigns`;

  constructor(private http: HttpClient) {}

  getCampaignsByClient(clientId: string): Observable<CampaignClient[]> {
    const url = `${this.baseUrl}/client/${clientId}?page=0&size=10&sortBy=createdAt&direction=ASC`;

    return this.http.get<any>(url).pipe(
      map(res => res.content as CampaignClient[])
    );
  }
}
